const categories = [
  { label: '动作片', icon: 'ri-sword-line', desc: '热血激战场面震撼', count: '2.3万部' },
  { label: '喜剧片', icon: 'ri-emotion-laugh-line', desc: '轻松欢乐笑料不断', count: '1.8万部' },
  { label: '爱情片', icon: 'ri-heart-line', desc: '浪漫温情感动人心', count: '1.6万部' },
  { label: '科幻片', icon: 'ri-rocket-line', desc: '想象无限未来之旅', count: '1.2万部' },
  { label: '恐怖片', icon: 'ri-ghost-smile-line', desc: '惊悚刺激心跳加速', count: '9千部' },
  { label: '动画片', icon: 'ri-palette-line', desc: '多彩世界创意无限', count: '1.5万部' },
  { label: '纪录片', icon: 'ri-earth-line', desc: '真实记录探索未知', count: '8千部' },
  { label: '战争片', icon: 'ri-shield-flash-line', desc: '史诗叙事震撼人心', count: '6千部' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-900">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 font-bold mb-3">
              分类索引
            </h2>
            <p className="text-sm text-foreground-400 max-w-lg mx-auto">
              按类型快速浏览海量免费影视资源，总有一款适合您
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {categories.map((cat) => (
              <a
                key={cat.label}
                href="#"
                onClick={(e) => e.preventDefault()}
                className="group flex items-start gap-4 p-5 bg-background-800/40 border border-background-700/30 rounded-xl hover:border-primary-500/25 hover:bg-background-800/70 transition-all duration-300 cursor-pointer"
              >
                <span className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-secondary-500/15 text-secondary-400 group-hover:bg-primary-500/15 group-hover:text-primary-400 transition-colors">
                  <i className={`${cat.icon} text-lg`}></i>
                </span>
                <div className="min-w-0">
                  <h3 className="font-heading text-sm text-foreground-100 font-bold mb-1 group-hover:text-primary-300 transition-colors">
                    {cat.label}
                  </h3>
                  <p className="text-xs text-foreground-500 mb-1.5">{cat.desc}</p>
                  <span className="text-xs text-foreground-600">{cat.count}</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}